/**
 * Builds authentication redirect URLs for /account/continue/
 */

export type AuthAction = 'sign_in' | 'sign_up';

export interface BuildAuthUrlOptions {
  next: string;
  action?: AuthAction;
}

export function buildAuthUrl(options: BuildAuthUrlOptions): string {
  const { next, action } = options;
  const params = new URLSearchParams();

  params.set('next', next);

  if (action) {
    params.set('action', action);
  }

  return `/account/continue/?${params.toString()}`;
}
